// Hide only the floating privacy shortcut in the Black Friday layout.
// The consent dialog and saved consent remain managed by Usercentrics.
if(document.body.classList.contains('bf-body')){
 let observer,timer,retry;
 const hideShortcut=()=>{
  const root=document.getElementById('usercentrics-cmp-ui')?.shadowRoot;
  if(!root?.querySelector('#uc-privacy-button'))return;
  if(!root.querySelector('[data-bf-cookie-style]')){
   const style=document.createElement('style');
   style.dataset.bfCookieStyle='';
   style.textContent='#uc-privacy-button{display:none!important}';
   root.append(style);
  }
  observer?.disconnect();clearTimeout(timer);clearInterval(retry);
 };
 observer=new MutationObserver(hideShortcut);
 observer.observe(document.documentElement,{childList:true,subtree:true});
 window.addEventListener('UC_UI_INITIALIZED',hideShortcut);
 retry=setInterval(hideShortcut,250);
 timer=setTimeout(()=>{observer.disconnect();clearInterval(retry)},30000);
 hideShortcut();
}
